import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';

import { MultiChartModel } from '../../models/multi-chart.model';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-multi-chart',
	templateUrl: './multi-chart.component.html',
	styleUrls: ['./multi-chart.component.scss'],
	encapsulation: ViewEncapsulation.None
})

/**
 * MultiChartComponent: Component, where the highchart chart objects are rendered upon.
 */
export class MultiChartComponent {
	@Input() public multiChartModels: Array<MultiChartModel>;
	@ViewChild('multiChartContainer') public container: ElementRef;
}
